import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';
import { shiftApplicationsRevokeShiftApplication } from '~/generated';
import { extractData } from '~/utils/query-utils';

type Variables = {
  shiftApplicationId: number;
  shiftId: number;
  turnId?: number;
};

export const useRevokeShiftApplication = (
  options: UseMutationOptions<void, unknown, Variables, unknown>
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (variables: Variables) =>
      extractData(
        shiftApplicationsRevokeShiftApplication({
          path: { shiftApplicationId: variables.shiftApplicationId },
        })
      ),
    mutationKey: ['shifts', 'revokeShiftApplication'],
    ...options,
    onSuccess(data, variables, mutationResult, context) {
      queryClient.invalidateQueries({
        queryKey: ['shifts', 'applicationEvents'],
      });
      if (variables.turnId) {
        queryClient.invalidateQueries({
          queryKey: ['turns', variables.turnId],
        });
      }
      options.onSuccess?.(data, variables, mutationResult, context);
    },
  });
};
